import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-11',
  templateUrl: './11.component.html',
  styleUrls: ['./11.component.scss'],
})
export class VbList11Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
